import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MainService } from 'projects/authentication/_services/main.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  constructor(
    private http: HttpClient,
    private authMain: MainService
  ) { }

  public doVoucherRedeem(params: { voucherId: number, offerId: number, providerId?: number, externalUserId?: string }) {
    return this.http.post<any>(`${this.authMain.relativeUrl}/upar-twt/voucher/redeem`, params, { headers: this.authMain.callHeaders() }).pipe(map(res => {
      return this.authMain.mapResponse(res);
    }));
  }

  public stockCheck(params: { voucherId: number }) {
    return this.http.post<any>(`${this.authMain.relativeUrl}/upar-twt/voucher/stock`, params, { headers: this.authMain.callHeaders() }).pipe(map(res => {
      return this.authMain.mapResponse(res);
    }));
  }

  public getTournaments(params: { count?: number, page?: number, state: number }) {
    return this.http.post<any>(`${this.authMain.relativeUrl}/upar-twt/tournaments`, params, { headers: this.authMain.callHeaders() }).pipe(map(res => {
      return this.authMain.mapResponse(res);
    }));
  }

}
